module.exports = __webpack_public_path__ + "static/media/DND.7de0b320.png";